import { Box, Typography } from "@mui/material";
import ViewCad from "../../../view";
import { ContasViewProps } from "../contas.controll";
import { Contas } from "../contas.model"
import { ViewSelecionarCliente } from "../../cliente/view/cliente.select";
import { ViewSelecionarFornecedor } from "../../fornecedor/view/forn.select";
import { StripedDataGrid } from "../../../components/select";
import { GridColDef } from "@mui/x-data-grid";
import { RecebimentoConta } from "../../../data.types";
import { formatData, formatMoney } from "../../../services/utils";

const columns: GridColDef[] = [
    { field: 'data', headerName: 'Data', flex: 3, renderCell: (prm) => formatData(prm.value) },
    { field: 'canal_dist.funcionario.nome', headerName: 'Funcionário', flex: 3, valueGetter: (value, row: RecebimentoConta) => row.canal_dist.funcionario.nome },
    { field: 'meio_pag.descricao', headerName: 'Meio Pagamento', flex: 4, valueGetter: (value, row: RecebimentoConta) => row.meio_pag.descricao },
    { field: 'valor', headerName: 'Valor', flex: 2, renderCell: (prm) => formatMoney(prm.value) },
]

interface ContasCadastroProps extends ContasViewProps {
    handleCloseView: () => any
}

export function ContasCadastro(props: ContasCadastroProps) {
    const { contasActions, contasState, handleCloseView, clienteActions, fornecedorActions } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status, contaGroup } = contasState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue, handleNovaConta } = contasActions

    const handleExcluir = (row: Contas) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Contas) => {
        const errors: any = {}
        if (!values.descricao)
            errors.descricao = "Informe uma breve descrição"
        return errors
    }

    const handleUpdate = (value: Contas) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        changeValue(state, field, () => value)
    }
    const handleSelecionarPessoa = () => {
        // abrir modal de seleção de pessoa
        switch (row.tipo) {
            case "pagar":
                fornecedorActions.setShowSelectModal(true);
                break;
            case "receber":
                clienteActions.setShowSelectModal(true);
                break;
        }
    }

    const RecebimentosView = () => {
        if (row.recebimentos.length > 0)
            return (
                <Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>Contas Recebidas</Typography>
                    <StripedDataGrid
                        disableRowSelectionOnClick
                        rows={row.recebimentos}
                        columns={columns}
                        getRowId={row => row._id}
                        density={'compact'}
                        style={{ fontSize: '0.875rem' }}
                        hideFooterPagination={true}
                        hideFooter={true}
                        filterMode="client"
                    />
                </Box>
            )
        return <Box></Box>
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro de contas a " + row.tipo,
        formFieldDescription: "descricao",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: false,
            title: "Adicionar nova conta",
            onClick: () => {},
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleMutator: handleMutator,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "pessoa.nome", label: "Nome", type: "select-dialog", key: "nome", colunsXS: 12, colunsSM: 12, colunsMD: 8, require: true, handleOnClickShow: () => handleSelecionarPessoa() },
            { fieldName: "valor", label: "Valor", type: "currency", key: "valor", colunsXS: 12, colunsSM: 12, colunsMD: 4 },
            { fieldName: "descricao", label: "Breve descrição", type: "text", key: "descricao", colunsXS: 12, colunsSM: 12, colunsMD: 6, },
            { fieldName: "data_venc", label: "Data Vencimento", type: "data", key: "vencimeno", colunsXS: 12, colunsSM: 12, colunsMD: 3, },
            { fieldName: "situacao", label: "Situação", type: "chip", key: "situacao",  colunsXS: 12, colunsSM: 12, colunsMD: 3, },
        ],
        ContentBox: (props) => {
            console.log("props ContentBox contas.cad", props)
            return (
                <Box sx={{ display: "flex", flex: 1 }}>
                    <RecebimentosView />
                    <ViewSelecionarCliente
                        handleConfirmar={(cliente) => props?.form.mutators.handleMutator({ _id: cliente._id, nome: cliente.nome }, "pessoa")}
                    />

                    <ViewSelecionarFornecedor
                        handleConfirmar={(forn) => props?.form.mutators.handleMutator({ _id: forn._id, nome: forn.nome }, "pessoa")}
                    />
                </Box>
            )
        }
    })

    return viewCad
}



